import { Grid } from "@mui/material";
import { IProps } from "../../types/CommonTypes";
import Title from "../generic/Title";
import { fieldLabel } from "./sections";
import Item from "./generic/ImageItem";
import { useEffect, useState } from "react";
import useFirebase from "../../commons/firebase/useFirebase";
import { getRandomId } from "../../commons/constants/helpers";

export default function DashboardForm({ item, onChange }: IProps) {
	const [data, setData] = useState(item);
	const { uploadFileToStorage } = useFirebase();

	useEffect(() => {
		onChange && onChange(data);
	}, [data]);

	const handleNewPic = async (id: string, file: any) => {
		try {
			let path = "/assets/reportForm/";
			const downloadURL = await uploadFileToStorage(
				file,
				path + file.name
			);
			let updated: any = data.images.map((item) => {
				if (item.id === id) {
					return {
						id: id,
						name: getRandomId(),
						path: path,
						url: downloadURL,
					};
				}
				return item;
			});

			setData({ ...data, images: updated });
		} catch (error) {
			console.log("Error al cargar el archivo:", error);
		}
	};

	return (
		<Grid container>
			<Title>Imágenes</Title>
			{data.images.map((image) => (
				<Item
					key={image.id}
					label={fieldLabel("reportForm", image.id)}
					source={image.url}
					onUpdate={(file: any) => handleNewPic(image.id, file)}
				/>
			))}
		</Grid>
	);
}
